export const MODES = {
  CHARGE: 'CHARGE',
  PAYMENT: 'PAYMENT',
  BONUS: 'BONUS',
};
